/**
 * -----------------------------------------------------------------------------
 * It renders a file icon with arrow to indicate upload
 */
export function FileArrowIcon() {
  return (
    <svg
      fill="none"
      height={28}
      viewBox="0 0 29 28"
      width={29}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1178_12217)">
        <path
          className="stroke-gray-950"
          d="M22.375 24.5H6.625C6.39294 24.5 6.17038 24.4078 6.00628 24.2437C5.84219 24.0796 5.75 23.8571 5.75 23.625V4.375C5.75 4.14294 5.84219 3.92038 6.00628 3.75628C6.17038 3.59219 6.39294 3.5 6.625 3.5H17.125L23.25 9.625V23.625C23.25 23.8571 23.1578 24.0796 22.9937 24.2437C22.8296 24.4078 22.6071 24.5 22.375 24.5Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="stroke-gray-950"
          d="M17.125 3.5V9.625H23.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="stroke-gray-950"
          d="M11.875 15.75L14.5 13.125L17.125 15.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="stroke-gray-950"
          d="M14.5 20.125V13.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1178_12217">
          <rect
            fill="white"
            height={28}
            transform="translate(0.5)"
            width={28}
          />
        </clipPath>
      </defs>
    </svg>
  );
}
